<div class="loading-cont" [ngClass]="{ 'loading-edit-page-cont': !listingPage }" *ngIf="loading"><div class="loading-spinner"></div></div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/loader/loader.component.html